import { lighten } from "@material-ui/core/styles/colorManipulator";
import { fade } from "@material-ui/core/styles/colorManipulator";
export const styles = theme => ({
  tableCellInCollapes: {
    borderBottom: 'none'
  },
  rootInput: {
    minHeight: '2rem'
  },
  root: {
    width: "100%",
    marginTop: theme.spacing(2)
  },
  iconEdit: {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  style: {
    display: "none"
  },
  activeChip: {
    backgroundColor: '#2db253',
    color: '#fff'
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  exact_filter: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  filterTextField: {
    minWidth: 140,
    textTransform: 'capitalize'
  },
  menu: {
    textTransform: 'capitalize'
  },
  packageName: {
    textTransform: 'capitalize'

  },
  noService: {
    maxWidth: 200,
    boxSizing: 'border-box'
  },
  icon: {
    fontSize: 40,
    float: "right",
    cursor: "pointer"
  },
  title1: {
    display: "inline-block",
    fontSize: 34,
    fontWeight: 500
  },
  tableCellEdit: {
    borderBottom: "none"
  },
  inputPhoneNumber: {
    border: "1px solid #d2d2d2",
    width: "98%",
    // marginTop: '30px',
    padding: "10px",
    "&:after": {
      borderBottomColor: "#fff"
    },
    "&:hover&:after ": {
      borderBottomColor: "#fff"
    }
  },
  rootDialogActions: {
    margin: 0,
    position: "absolute",
    top: "0%",
    right: "0%"
  },
  title: {
    fontWeight: 500,
    marginTop: "3.268%",
    // marginBottom: '3.268%',
    fontSize: "24px",
    textAlign: "center"
  },
  paperWidthSm: {
    width: "80%",
    margin: "8.542% 18.125%",
    maxWidth: "unset"
    // height: '77.71%'
  },
  footer: {
    // justifyContent: 'space-between',
    // display: 'flex',
    // bottom: '10%',
    // position: 'absolute',
    marginBottom: "3.268%",
    marginTop: "2rem",
    padding: "0px  !important",
    display: "flex",
    justifyContent: "flex-end"
  },
  button: {
    // marginTop: '2rem',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  note: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(0, 0, 0, 0.5)"
  },
  boxCountryCode: {
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: "6px !important"
  },
  actionColumn: {
    minWidth: 'max-content'
  }
});

export const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing(1)
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85)
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark
      },
  spacer: {
    flex: "1 1 100%"
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: "0 0 auto"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "20%",
    float: "right"
  },
  icon: {
    marginTop: theme.spacing(3),
    width: 36,
    height: 36,
    left: -8
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade("#9E9E9E", 0.15),
    "&:hover": {
      backgroundColor: fade("#9E9E9E", 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    }
  },
  searchIcon: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit",
    width: "100%"
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200
      }
    }
  }
});

export const tablecellStyles = theme => ({
});

export const textFieldStyles = theme => ({
  submitActive: {
    width: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    /* margin-top: 24px; */
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    // marginBottom: theme.spacing(1),
    padding: theme.spacing(3),
    // borderBottom: "1px solid rgba(224, 224, 224, 1)"
  },
  button: {
    // fontSize: '12px',
    // width: '26px',
    // height: '14px',
    float: 'right',
  },
  containerButton: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  textField: {
    // marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%"
  },
  menu: {
    width: "15%"
  },
  input: {
    // fontSize : 18
  },
  label: {
    fontWeight: 410,
    marginLeft: 0
  },
  actives: {
    fontSize: 16,

    // marginLeft: "60px",
    display: "inline-block"
  },
  button: {
    // marginLeft: "60px",
    // fontSize: "12px",
    // width: "26px",
    // height: "14px"
  },
  switchBase: {
    "&$switchChecked": {
      color: theme.palette.common.white,
      "& + $switchBar": {
        backgroundColor: "#52d869"
      }
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp
    })
  },
  switchChecked: {
    transform: "translateX(15px)",
    "& + $switchBar": {
      opacity: 1,
      border: "none"
    }
  },
  switchBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"])
  },
  switchIcon: {
    width: 24,
    height: 24
  },
  switchIconChecked: {
    boxShadow: theme.shadows[1]
  },
  buttonModule: {
    marginRight: '1rem',
  }
});
